@if (isLoading()) {
  <app-loading-indicator></app-loading-indicator>
} @else {
  <section>
    <div class="container-one">
      <div class="curve top-left-curve"></div>

      <div class="number">
        <img src="/auth/number-one.png" alt="number one image">
      </div>

      <div class="curve bottom-left-curve"></div>
    </div>

    <div class="container-two">
      <div class="content">
        <h3>Create School Profile</h3>

        <p>Register the school identity and physical location details.</p>

        <form #profileForm="ngForm" (ngSubmit)="createSchoolProfile(profileForm)">
          <div class="form-group">
            <label for="schoolName">School Name</label>
            <input disabled required [(ngModel)]="schoolName"  (ngModelChange)="schoolName.set($event)" type="text" name="schoolName" id="schoolName">
          </div>

          <div class="form-group">
            <label for="schoolLocation">School Location/Address</label>
            <input disabled required [(ngModel)]="location"  (ngModelChange)="location.set($event)" type="text" name="schoolLocation" id="schoolLocation">
            <img class="location-icon" src="/auth/location-icon.png" alt="location icon">
          </div>

          <div class="form-group">
            <label for="phone">Phone</label>
            <input required [(ngModel)]="phone" type="text" name="phone" id="phone" placeholder="e.g. 020 586 1876">
          </div>

          <div class="form-group">
            <label for="schoolImage">School Logo Asset</label>

            <div>
              <input (change)="onFileSelected($event)" type="file" name="schoolImage" id="schoolImage" accept="image/*">
              @if (imagePreview) {
                <img class="image-uploaded" [src]="imagePreview" alt="image uploaded">
              } @else {
                <img src="/auth/upload-icon.png" alt="upload icon" class="upload-icon">
                <p>Drag & drop logo image here</p>
                <small>JPEG or PNG max 2MB (200x200px recommended)</small>
              }
            </div>
          </div>

          <div class="color-inputs">

            <label for="primaryColor">Primary Color</label>
            <label for="secondaryColor">Secondary Color</label>

            <div>
              <input required [(ngModel)]="primaryColor" type="color" name="primaryColor" id="primaryColor">

              <p>{{ primaryColor }}</p>
            </div>

            <div>
              <input required [(ngModel)]="secondaryColor" type="color" name="secondaryColor" id="secondaryColor">

              <p>{{ secondaryColor }}</p>
            </div>
          </div>

          <div class="foot">
            <div class="info">
              <div><img src="/auth/info-icon.png" alt="info icon"></div>
              <small>You can edit these details later in School Profile.</small>
            </div>

            <button [disabled]="profileForm.invalid" class="button" type="submit">
              @if (isSubmitting()) {
                <app-loading-indicator></app-loading-indicator>
              } @else {
                Next
              }
            </button>
          </div>

        </form>


      </div>
    </div>

  </section>
}
